import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Divider, Image, Stack, Text, rem } from '@mantine/core';
import classes from './BunkerSuccess.module.css';
export const BunkerSuccessSection: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Stack gap={28}>
      <Image src="/assets/icon_success.svg" alt="success-icon" w={{
      base: 80,
      sm: 96
    }} h={{
      base: 80,
      sm: 96
    }} mx={{
      base: 'auto',
      lg: 0
    }} />
      <Text className={gunterzBold.className} c="var(--text-prime)" ta={{
      base: 'center',
      lg: 'left'
    }} fz={{
      base: 28,
      sm: 24,
      lg: 32
    }} lh={{
      base: rem(30),
      sm: rem(24),
      lg: rem(33)
    }}>
        {i18n._('Success!')}
      </Text>

      <Divider classNames={{
      root: classes.divider
    }} />

      <Text className={gunterzBold.className} c="var(--text-white)" fz={{
      base: 21,
      sm: 18,
      lg: 21
    }} ta={{
      base: 'center',
      lg: 'left'
    }} lh={{
      base: rem(24),
      sm: rem(22),
      lg: rem(27)
    }}>
        {i18n._('Your primeorb has been updated!')}
      </Text>

      <Divider classNames={{
      root: classes.divider
    }} />

      <Text fw={700} tt="uppercase" c="var(--text-dark)" fz="xs" lh={rem(15)} ta={{
      base: 'center',
      lg: 'left'
    }}>
        {i18n._('Your updated Primeorb now unlocks exclusive rewards and bonuses for your casino gameplay.')}
      </Text>

      <Text fw={700} tt="uppercase" c="var(--text-dark)" fz="xs" lh={rem(15)} ta={{
      base: 'center',
      lg: 'left'
    }}>
        {i18n._('Equip it and start spinning to win bigger than ever!')}
      </Text>
    </Stack>;
};